import React, {useCallback, useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'

import {
  setTransactionTypeState,
  selectTransactionTypeState,
} from '../../../app-store/AccountSetupSlice'

import {
  Container,
  // Label,
  SegmentedControl,
  // SegmentButton,
  // TooltipWrapper,
  // TooltipIcon,
  // TooltipContent,
} from './TransactionType.styles'
import {Button} from '../../shared/Button'

const OPTIONS = [
  {
    id: 'single-location',
    label: 'Single Location',
    tooltip: 'Best for businesses operating from a single location.',
  },
  {
    id: 'multiple-locations',
    label: 'Multiple Locations',
    tooltip: 'Best for businesses with multiple branches or store locations.',
  },
]

const DEFAULT_TYPE = 'single-location'

export function TransactionType({onChange, disabled = false}) {
  const dispatch = useDispatch()

  const {selectedTransactionType} = useSelector(selectTransactionTypeState)

  useEffect(() => {
    if (!selectedTransactionType) {
      dispatch(setTransactionTypeState(DEFAULT_TYPE))
    }
  }, []) // eslint-disable-line

  const activeType = selectedTransactionType ?? DEFAULT_TYPE

  const handleSelect = useCallback(
    type => {
      onChange?.(type)
    },
    [onChange],
  )

  return (
    <Container>
      {/* <Label>Transaction Type</Label> */}

      <SegmentedControl disabled={disabled}>
        {OPTIONS.map(option => {
          const isSelected = activeType === option.id

          return (
            // <SegmentButton
            //   key={option.id}
            //   isSelected={isSelected}
            //   disabled={disabled}
            //   onClick={() => handleSelect(option.id)}
            // >
            //   <span>{option.label}</span>
            // </SegmentButton>
            <Button
              key={option.id}
              size="sm"
              variant={
                isSelected
                  ? 'secondary-toggle-active'
                  : 'secondary-toggle-inactive'
              }
              // isSelected={isSelected}
              disabled={disabled}
              onClick={() => handleSelect(option.id)}
            >
              <span>{option.label}</span>
            </Button>
          )
        })}
      </SegmentedControl>
    </Container>
  )
}
